export class TermScheduleFlags {
  constructor(
    private schedulerConfigModel: any,
    private FEATURE_WAITLIST_NK: string,
    private FEATURE_REG_SECTION_PIN: string,
    private FEATURE_ONE_CLICK_REGISTRATION_NK: string
  ) {}

  isWaitlistEnabled() {
    return this.schedulerConfigModel.isFeatureEnabled(this.FEATURE_WAITLIST_NK);
  }
  isFullSectionsSchedulingEnabled() {
    return this.schedulerConfigModel.isFeatureEnabled('reg-allow_register_full_section');
  }
  isWithdrawEnabled() {
    return this.schedulerConfigModel.isFeatureEnabled('reg-section_withdraw');
  }
  isOneClickRegistrationEnabled() {
    return this.schedulerConfigModel.isFeatureEnabled(this.FEATURE_ONE_CLICK_REGISTRATION_NK);
  }

  allowWaitlistedSectionsForRegistrationSelection() {
    return this.schedulerConfigModel.isFeatureEnabled('reg-allow_waitlisted_sections_for_registration_selection');
  }

  isCoreqEnforcementEnabled() {
    return this.schedulerConfigModel.isFeatureEnabled('reg-coreqs_enforcement');
  }
  isRequisiteReminderEnabled() {
    return this.schedulerConfigModel.isFeatureEnabled('reg-requisite_reminder');
  }
  isBatchRegisterWaitlistedStudentsEnabled() {
    return this.schedulerConfigModel.isFeatureEnabled('reg-batch_register_waitlisted_students');
  }
  getNumberOfSeatsRequestsPerCourse() {
    return this.schedulerConfigModel.getConfigProperty('reg-number_of_seat_requests_per_course');
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/services/term_schedule_flags.ts